/* eslint-disable */
;(function(d) {
  var c

  var v =
    '<svg><symbol id="icon-keyboard" viewBox="0 0 1024 1024"><path d="M945.23 671.508c21.662 0 39.385-17.723 39.385-39.385v-512c0-21.661-17.723-39.385-39.384-39.385H78.769c-21.661 0-39.384 17.724-39.384 39.385v512c0 21.662 17.723 39.385 39.384 39.385h866.462z m-827.076-78.77v-433.23h787.692v433.23H118.154z m151.63-328.861c0 15.754-13.784 29.538-29.538 29.538h-19.692c-15.754 0-29.539-13.784-29.539-29.538v-19.692c0-15.754 13.785-29.539 29.539-29.539h19.692c15.754 0 29.539 13.785 29.539 29.539v19.692z m112.247-19.692c0-15.754-13.785-29.539-29.539-29.539H332.8c-15.754 0-29.538 13.785-29.538 29.539v19.692c0 15.754 13.784 29.538 29.538 29.538h19.692c15.754 0 29.539-13.784 29.539-29.538v-19.692z m226.461 19.692c0 15.754-13.784 29.538-29.538 29.538h-19.692c-15.754 0-29.539-13.784-29.539-29.538v-19.692c0-15.754 13.785-29.539 29.539-29.539h19.692c15.754 0 29.538 13.785 29.538 29.539v19.692z m-114.215 0c0 15.754-13.785 29.538-29.539 29.538h-19.692c-15.754 0-29.538-13.784-29.538-29.538v-19.692c0-15.754 13.784-29.539 29.538-29.539h19.692c15.754 0 29.539 13.785 29.539 29.539v19.692z m340.677-19.692c0-15.754-13.785-29.539-29.539-29.539h-19.692c-15.754 0-29.538 13.785-29.538 29.539v19.692c0 15.754 13.784 29.538 29.538 29.538h19.692c15.754 0 29.539-13.784 29.539-29.538v-19.692z m-114.216 0c0-15.754-13.784-29.539-29.538-29.539h-19.692c-15.754 0-29.539 13.785-29.539 29.539v19.692c0 15.754 13.785 29.538 29.539 29.538H691.2c15.754 0 29.538-13.784 29.538-29.538v-19.692zM269.785 382.03c0 15.754-13.785 29.538-29.539 29.538h-19.692c-15.754 0-29.539-13.784-29.539-29.538v-19.693c0-15.753 13.785-29.538 29.539-29.538h19.692c15.754 0 29.539 13.785 29.539 29.538v19.693z m112.246-19.693c0-15.753-13.785-29.538-29.539-29.538H332.8c-15.754 0-29.538 13.785-29.538 29.538v19.693c0 15.754 13.784 29.538 29.538 29.538h19.692c15.754 0 29.539-13.784 29.539-29.538v-19.693z m226.461 19.693c0 15.754-13.784 29.538-29.538 29.538h-19.692c-15.754 0-29.539-13.784-29.539-29.538v-19.693c0-15.753 13.785-29.538 29.539-29.538h19.692c15.754 0 29.538 13.785 29.538 29.538v19.693z m-114.215 0c0 15.754-13.785 29.538-29.539 29.538h-19.692c-15.754 0-29.538-13.784-29.538-29.538v-19.693c0-15.753 13.784-29.538 29.538-29.538h19.692c15.754 0 29.539 13.785 29.539 29.538v19.693z m340.677-19.693c0-15.753-13.785-29.538-29.539-29.538h-19.692c-15.754 0-29.538 13.785-29.538 29.538v19.693c0 15.754 13.784 29.538 29.538 29.538h19.692c15.754 0 29.539-13.784 29.539-29.538v-19.693z m-114.216 0c0-15.753-13.784-29.538-29.538-29.538h-19.692c-15.754 0-29.539 13.785-29.539 29.538v19.693c0 15.754 13.785 29.538 29.539 29.538H691.2c15.754 0 29.538-13.784 29.538-29.538v-19.693zM269.785 500.185c0 15.753-13.785 29.538-29.539 29.538h-19.692c-15.754 0-29.539-13.785-29.539-29.538v-19.693c0-15.754 13.785-29.538 29.539-29.538h19.692c15.754 0 29.539 13.784 29.539 29.538v19.693z m450.953-19.693c0-15.754-13.784-29.538-29.538-29.538H332.8c-15.754 0-29.538 13.784-29.538 29.538v19.693c0 15.753 13.784 29.538 29.538 29.538h358.4c15.754 0 29.538-13.785 29.538-29.538v-19.693z m114.216 0c0-15.754-13.785-29.538-29.539-29.538h-19.692c-15.754 0-29.538 13.784-29.538 29.538v19.693c0 15.753 13.784 29.538 29.538 29.538h19.692c15.754 0 29.539-13.785 29.539-29.538v-19.693zM356.43 732.554h311.138c9.846 0 15.754 11.815 7.877 19.692l-151.63 187.077c-5.908 5.908-17.724 5.908-21.662 0l-153.6-187.077c-5.908-7.877-1.97-19.692 7.877-19.692z"  ></path></symbol></svg>'

  var e = (c = document.getElementsByTagName('script'))[
    c.length - 1
  ].getAttribute('data-injectcss')
  if (e && !d.__iconfont__svg__cssinject__) {
    d.__iconfont__svg__cssinject__ = !0
    try {
      document.write(
        '<style>.svgfont {display: inline-block;width: 1em;height: 1em;fill: currentColor;vertical-align: -0.1em;font-size:16px;}</style>'
      )
    } catch (c) {
      console && console.log(c)
    }
  }
  !(function(c) {
    if (document.addEventListener) {
      if (~['complete', 'loaded', 'interactive'].indexOf(document.readyState)) {
        setTimeout(c, 0)
      } else {
        var e = function() {
          document.removeEventListener('DOMContentLoaded', e, !1), c()
        }
        document.addEventListener('DOMContentLoaded', e, !1)
      }
    } else {
      document.attachEvent &&
        ((t = c),
        (n = d.document),
        (o = !1),
        (i = function() {
          o || ((o = !0), t())
        }),
        (v = function() {
          try {
            n.documentElement.doScroll('left')
          } catch (c) {
            return void setTimeout(v, 50)
          }
          i()
        })(),
        (n.onreadystatechange = function() {
          n.readyState == 'complete' && ((n.onreadystatechange = null), i())
        }))
    }
    var t, n, o, i, v
  })(function() {
    var c, e, t, n, o, i
    ;((c = document.createElement('div')).innerHTML = v),
      (v = null),
      (e = c.getElementsByTagName('svg')[0]) &&
        (e.setAttribute('aria-hidden', 'true'),
        (e.style.position = 'absolute'),
        (e.style.width = 0),
        (e.style.height = 0),
        (e.style.overflow = 'hidden'),
        (t = e),
        (n = document.body).firstChild
          ? ((o = t), (i = n.firstChild).parentNode.insertBefore(o, i))
          : n.appendChild(t))
  })
})(window)



// WEBPACK FOOTER //
// ./src/font/iconfont_keyboard.js